import { withInstall } from '@element-plus/utils'
import TableV3 from './src/table-v3.vue'

export const ElTableV3 = withInstall(TableV3)
export default ElTableV3

export * from './src/table-v3'
